export class PricingMatrixHelper {
  static transform(pricingMatrix: any): any[] {
    const structured: any[] = [];

    for (const zone in pricingMatrix) {
      const zoneData = pricingMatrix[zone];
      const zoneObj: any = { zone };

      const tierKeys = Object.keys(zoneData);

      // Case: No tier selected — directly check for age or variant
      if (tierKeys.length === 1 && tierKeys[0] === 'default') {
        Object.assign(zoneObj, this.processTier(zoneData['default']));
      } else {
        zoneObj.tiers = tierKeys.map(tier =>
          this.processTierWithName(tier, zoneData[tier])
        );
      }

      structured.push(zoneObj);
    }

    return structured;
  }

  private static processTierWithName(tier: string, tierData: any): any {
    const result = this.processTier(tierData);
    return {
      name: tier,
      ...result
    };
  }

  private static processTier(tierData: any): any {
    const ageKeys = Object.keys(tierData);

    // No age bands — direct variant/category or pricing
    if (ageKeys.length === 1 && ageKeys[0] === 'default') {
      return this.processAge(tierData['default']);
    } else {
      const ageBands = ageKeys.map(age =>
        this.processAgeWithName(age, tierData[age])
      );

      return {
        ageBands: ageBands.filter(b => b != null)
      };
    }
  }

  private static processAgeWithName(age: string, data: any): any {
    const result = this.processAge(data);
    return {
      name: age,
      ...result
    };
  }

  private static processAge(data: any): any {
    const variantKeys = Object.keys(data);

    // No variants — either categories or direct pricing
    if (variantKeys.length === 1 && variantKeys[0] === 'default') {
      const categories = this.extractCategories(data['default']);
      if (categories.length > 0) {
        return { categories };
      } else {
        return this.extractPricing(data['default']);
      }
    } else {
      const variants = variantKeys.map(variant => {
        const categories = this.extractCategories(data[variant]);

        if (categories.length > 0) {
          return {
            name: variant,
            categories
          };
        } else {
          return {
            name: variant,
            ...this.extractPricing(data[variant])
          };
        }
      });

      return { variants };
    }
  }

  private static extractCategories(categoryLevel: any): any[] {
    if (!categoryLevel || typeof categoryLevel !== 'object') return [];

    return Object.keys(categoryLevel).map(category => ({
      name: category,
      unitPrice: categoryLevel[category]['Unit Price'] ?? 0,
      advisorCommission: categoryLevel[category]['Advisor Commission'] ?? 0,
      tpaCommission: categoryLevel[category]['TPA Commission'] ?? 0,
      otherFees: categoryLevel[category]['Other Fees'] ?? 0
    }));
  }

  private static extractPricing(node: any) {
    return {
      unitPrice: node['Unit Price'] ?? 0,
      advisorCommission: node['Advisor Commission'] ?? 0,
      tpaCommission: node['TPA Commission'] ?? 0,
      otherFees: node['Other Fees'] ?? 0
    };
  }
}
